module.exports = __webpack_public_path__ + "img/horizontal_7_4_8004.b416af2b.png";